export const environment = {
  production: false,
  baseUrl: 'https://tpv-admin.cangasaventura.com/api',
  baseUrlWeb: 'https://tpv-admin.cangasaventura.com',
  webUrl: 'https://tpv.cangasaventura.com',
  limitActivitiesOfDashboard: 5
};
